import { generateIndexArray } from '@utils/array';

export const DATE_RANGE = 7;
export const DEFAULT_DATE_DIFFERENCE = DATE_RANGE * 2;
export const DATE_RANGE_SPAN = DATE_RANGE * 3;
export const SCROLL_SPEED = 200;

export const INITIAL_DATES = Object.freeze(
  generateIndexArray(DATE_RANGE_SPAN).map(index => index - DATE_RANGE)
);
